import { Notify } from 'notiflix/build/notiflix-notify-aio';

import {
  setPartnerArticle,
  setResaleArticles,
} from '@/redux/partners/partnersSlice';

import partnersService from '@/services/partnersService';

const getResaleArticles = () => async dispatch => {
  try {
    const response = await partnersService.getArticles('api');
    const { data } = response;

    dispatch(setResaleArticles(data));
  } catch (e) {
    Notify.failure(
      e.response?.data?.message || 'Request GetResaleArticles failure',
    );
  }
};

const getArticle = id => async dispatch => {
  try {
    const response = await partnersService.getArticle(id);
    const { data } = response;

    dispatch(setPartnerArticle(data));
  } catch (e) {
    Notify.failure(e.response?.data?.message || 'Request GetArticle failure');
  }
};

export default {
  getResaleArticles,
  getArticle,
};
